import { render, staticRenderFns } from "./clockinrecord.vue?vue&type=template&id=4f2f5b4f"
import script from "./clockinrecord.vue?vue&type=script&lang=js"
export * from "./clockinrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports